import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CheckoutPage.css';

const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.glowapp.me';

const APP_SCHEME = {
  success: 'GlowApp://payment/success',
  cancel: 'GlowApp://payment/cancel',
  portal: 'GlowApp://payment/portal-return',
};

const isMobileBrowser = () =>
  typeof navigator !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const PaymentResultPage = ({ kind }) => {
  const { t } = useTranslation();
  const success = kind === 'success';
  const portal = kind === 'portal';
  const deepLink = APP_SCHEME[kind] || APP_SCHEME.success;
  const mobile = isMobileBrowser();
  const primaryHref = mobile ? deepLink : APP_URL;
  const title = portal
    ? (t('paymentPortalTitle') || 'Back to GlowApp')
    : success
      ? t('paymentSuccessTitle')
      : t('paymentCancelTitle');
  const body = portal
    ? (t('paymentPortalBody') || 'You can return to the app. Your subscription details will refresh.')
    : success
      ? t('paymentSuccessBody')
      : t('paymentCancelBody');

  React.useEffect(() => {
    if (!mobile) return undefined;
    const timer = window.setTimeout(() => {
      window.location.href = deepLink;
    }, 400);
    return () => window.clearTimeout(timer);
  }, [deepLink, mobile]);

  return (
    <div className="checkout-page">
      <main className="checkout-main">
        <h1>{title}</h1>
        <p className="checkout-subtitle">{body}</p>
        <p>
          <a className="btn btn-primary" href={primaryHref}>
            {mobile ? (t('openGlowApp') || 'Open GlowApp') : t('checkoutLoginCta')}
          </a>
        </p>
        {mobile && (
          <p>
            <a className="checkout-back" href={APP_URL}>{t('checkoutLoginCta')}</a>
          </p>
        )}
        <p>
          <Link to="/" className="checkout-back">{t('checkoutBack')}</Link>
        </p>
      </main>
    </div>
  );
};

export default PaymentResultPage;
